/** Restaurant Information related settings */
export interface IRestaurantSettings {
	/** Default contact email */
	email: string
	/** Default contact phone number */
	phone?: string
	/** Restaurant address */
	address: string
	/** Restaurant's Google Place ID */
	googlePlaceId: string
	/** Restaurant's timezone */
	timezone: string
}
